<template>
  <div>
    <v-btn
      class="primary"
      @click="showConfirmButtonClickEvent"
    >
      対象のマニフェスト
    </v-btn>
    <v-dialog
      v-model="enableDialog"
      persistent
      width="680"
    >
      <v-card>
        <v-card-title class="info white--text">
          確認
        </v-card-title>
        <v-divider />
        <v-card-text class="mt-2">
          <h3>入力中の受注データは保存されませんが、マニフェスト管理画面へ遷移しますか？</h3>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="closeButtonClickEvent"
          >
            CANCEL
          </v-btn>
          <v-btn
            class="primary"
            @click="okButtonClickEvent"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/**
 * 対象のマニフェストボタン
 */
export default {
  name: "TransitionManifestButton",
  components: {},
  mixins: [],
  props: {
    requestNo: {
      type: Number,
      default: () => null,
    },
    orderId: {
      type: Number,
      default: () => null,
    },
    orderType: {
      type: String,
      default: () => null,
    },
    showConfirm: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      enableDialog: false,
    }
  },
  computed: {},
  watch: {},
  created() {},
  methods: {
    showConfirmButtonClickEvent () {
      if ( this.showConfirm ) {
        this.enableDialog = true
      } else {
        this.okButtonClickEvent()
      }
    },
    closeButtonClickEvent () {
      this.enableDialog = false
    },
    okButtonClickEvent () {
      const params = {  order_type: this.orderType, order_id: this.orderId }
      this.$router.push( { name: 'DriverManifestManagements', params: params } )
    },
  }
}
</script>

<style scoped lang="scss">

</style>
